import { render, staticRenderFns } from "./ProductPriceCollapse.vue?vue&type=template&id=dec8ff98&scoped=true&"
import script from "./ProductPriceCollapse.vue?vue&type=script&lang=js&"
export * from "./ProductPriceCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceCollapse.vue?vue&type=style&index=0&id=dec8ff98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec8ff98",
  null
  
)

export default component.exports